export default "__VITE_ASSET__f9fd6364__"